import { render, staticRenderFns } from "./EditRoServiceCustomer.vue?vue&type=template&id=3c6509b2"
import script from "./EditRoServiceCustomer.vue?vue&type=script&lang=js"
export * from "./EditRoServiceCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports